import { useId } from "react";
import { useCharacter } from "../character";

/** Input for the full name, the heading of the sheet; empty means the short name everywhere. */
export function FullNameField() {
  const { character, apply } = useCharacter();
  const id = useId();
  const current = character.fullName ?? "";
  return (
    <div className="field">
      <label htmlFor={id} className="muted small">
        Vollständiger Name
      </label>
      <input
        id={id}
        key={current}
        defaultValue={current}
        placeholder={character.name}
        onBlur={(e) => {
          const value = e.target.value.trim();
          if (value !== current) void apply({ type: "core.fullName", payload: { fullName: value } });
        }}
      />
      <span className="muted small">Überschrift auf Bogen und PDF; leer heißt: „{character.name}“.</span>
    </div>
  );
}
